<template>
  <section class="product-grid-section">
    <div class="container">
      <div
        v-if="!isLoading && !(productList && productList.length)"
        class="text-center text-muted py-5"
      >
        <i class="bi bi-box-seam d-block mb-2" style="font-size: 2rem"></i>
        <p class="mb-0">No products found.</p>
      </div>
      <div v-else class="row g-4">
        <div
          v-for="(productWrapper, index) in productList"
          :key="index"
          class="col-12 col-md-6 col-xl-4"
        >
          <div class="product-card">
            <router-link
              :to="'/product/' + productWrapper.product._id"
              style="text-decoration: none"
            >
              <img
                :src="
                  productWrapper.product.images?.length ? `${BASE_IMAGE_PREFIX}/${productWrapper.product.images[0]}` : `${PLACEHOLDER_IMAGE}`"
                :alt="productWrapper.product.title"
                class="product-image"
              />
            </router-link>
            <div class="product-details">
              <router-link
                :to="'/product/' + productWrapper.product._id"
                style="text-decoration: none"
              >
                <h3 class="product-title">{{ productWrapper.product.title }}</h3>
              </router-link>
              <router-link
                v-if="productWrapper.product.productCategory !== 'stationary'"
                :to="'/brand/' + productWrapper.product.brand.replace(/ /g, '_')"
                style="text-decoration: none"
              >
                <div class="product-brand">{{ productWrapper.product.brand }}</div>
              </router-link>
              <div class="product-price" v-if="productWrapper.product.minVariant">
                <span v-if="productWrapper.product.minVariant.isOnSale && productWrapper.product.minVariant.salePrice">
                  <span class="text-decoration-line-through text-muted me-1">
                    ৳ {{ productWrapper.product.minVariant.price }}
                  </span>
                  <span>
                    ৳ {{ productWrapper.product.minVariant.salePrice }}
                  </span>
                </span>

                <span v-else>
                  ৳ {{ productWrapper.product.minVariant.price }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { BASE_IMAGE_PREFIX, PLACEHOLDER_IMAGE } from '@/globals';

export default {
  name: "ProductGridSection",
  props: {
    productList: {
      type: Array,
      default: () => [],
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      BASE_IMAGE_PREFIX,
      PLACEHOLDER_IMAGE,
    }
  },
};
</script>

<style lang="scss" scoped>
.product-grid-section {
  padding: 40px 0;
  background-color: #fff;

  .product-card {
    display: flex;
    border-bottom: 1px solid #e3e3e3;
    padding-bottom: 20px;
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-5px);
    }

    .product-image {
      width: 120px;
      height: 150px;
      overflow: hidden;
      border-radius: 8px;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .product-details {
      padding-left: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .product-title {
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 5px;
        color: #333;
      }

      .product-brand {
        color: #888;
        font-size: 14px;
        margin-bottom: 8px;
      }

      .product-price {
        color: #e61e25;
        font-size: 18px;
        font-weight: 600;
      }
    }
  }
}
</style>
